import { get, post, put, patch, deleted } from "../index";
import AuthRoutes from "./Auth.routes";

const AuthServices = {
  getAllJobs: async (page, limit, userId, adId, role, category, createdAtFrom, createdAtTo, validTillFrom, validTillTo, status) => {
    console.log("🚀 ~ getAllJobs: ~ status:", status)
    // "page, rows, userId, adId, role, category, createdAt, validTill, status"
    let params = `?page=${page}&limit=${limit}`;
    if (userId) params += `&user_id=${userId}`;
    if (adId) params += `&adId=${adId}`;
    if (role) params += `&role=${role}`;
    if (category) params += `&category=${category}`;
    if (createdAtFrom) params += `&created_at_from=${createdAtFrom}`;
    if (createdAtTo) params += `&created_at_to=${createdAtTo}`;
    if (validTillFrom) params += `&valid_till_from=${validTillFrom}`;
    if (validTillTo) params += `&valid_till_to=${validTillTo}`;
    if (status == "Completed") {
      params += `&isCompleted=${true}`
    } else if (status == "Pending") {
      params += `&isApproved=${null}`
    } else if (status == "Posted") {
      params += `&isApproved=${true}`
    } else if (status == "Active") {
      params += `&isHired=${true}`
    } else if (status == "Featured") {
      params += `&featured=${true}`
    }
    const result = await get(AuthRoutes.getAllJobs + params);
    return result;
  },

  getAllUsers: async (page, limit, name, industry, service, phone, role) => {
    let params = `?page=${page}&limit=${limit}&role=${role}`;
    if (name) params += `&name=${name}`
    if (industry) params += `&industry=${industry}`
    if (service) params += `&services=${service}`
    if (phone) params += `&phone_Number=${phone}`

    const result = await get(AuthRoutes.getAllUsers + params);
    return result;
  },

  login: async (obj) => {
    const result = await post(AuthRoutes.login, obj);
    return result;
  },

  approveAd: async (id, obj) => {
    const result = await patch(AuthRoutes.approveAd + `/${id}`, obj);
    return result;
  },

  approveFeature: async (id, obj) => {
    const result = await put(AuthRoutes.approveFeature + `?adId=${id}`, obj);
    return result;
  },

  getWithdrawRequests: async (page, limit, from, to) => {
    const result = await get(AuthRoutes.getWithdrawRequests + `?page=${page}&limit=${limit}&from=${from}&to=${to}`);
    return result;
  },

  updateWithdrawRequest: async (id, obj) => {
    const result = await put(AuthRoutes.updateWithdrawRequest + `/${id}`, obj);
    return result;
  },

  getPlatformFee: async () => {
    const result = await get(AuthRoutes.getPlatformFee);
    return result;
  },

  updatePlatformFee: async (obj) => {
    const result = await patch(AuthRoutes.updatePlatformFee, obj);
    return result;
  },

  getTransactionHistory: async (user_id, page, limit) => {
    const result = await get(AuthRoutes.getTransactionHistory + `?user_id=${user_id}&page=${page}&limit=${limit}`);
    return result;
  },
}

export default AuthServices;